import { React } from "react";
import PageTitle from "../Components/PageTitle";
import { Input } from "reactstrap";

export default function ContactUs() {

  return (
    <>
      <PageTitle title="DeepTherapy | Contact" />
      <div className="card w-100">
        <div className="card-header bg-white d-flex align-items-center justify-content-between flex-wrap">
          <div className="card-header-left">
            <div className="card-header-top d-flex align-items-center flex-wrap mb-2">
              <div className="card-title">Contact Us</div>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="profile-form-block">
            <div className="row">
              <p>If you experience any issues or would like to share your feedback on the platform, feel free to reach out to us!</p>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="mb-2">Email</label>
                  <Input
                      type="email"
                      className="form-control mb-2"
                      id="email"
                      name="email"
                      value="info@deeptherapy.nl"
                      disabled="disabled"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
